import styled from 'styled-components';

export const Wrapper = styled.div``;

export const SubMenuWrapper = styled.div`
  top: 58px;
  position: relative;
  z-index: 99;
`;
